import React from "react";
import ProfileSectionCard from "./ProfileSectionCard";

const PracticeLocations = ({ profile }) => {
  const locations_array = profile?.locations || [];

  const formatText = (str) => {
    if (!str) return "";
    const cleaned = String(str).replace(/_/g, " ");
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  };

  const formatTime = (timeStr) => {
    if (!timeStr || !timeStr.includes(":")) return timeStr;
    const [hourStr, minuteStr] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    const am_pm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour ? hour : 12;

    return `${hour}:${minuteStr}${am_pm}`;
  }

  return (
    <ProfileSectionCard title="Practice Information" showEditButton={false}>
      <p className="text-muted mb-6">To add a practice location, contact BookDoc at <span className="highlighted">1300-88-2362</span> or email <a href={`mailto: care@bookdoc.com`} className="highlighted">care@bookdoc.com</a>.</p>
      <div className="profile-info-group">
        <div className= "profile-info-label  mt-4">Practice Location</div>
        {locations_array.length === 0 ? (
          <p>No practice locations found.</p>
        ) : (
          <div className="table-responsive">
            <table className="table mt-3 table-style">
              <thead>
                <tr className="table-header">
                  <th scope="col" style={{ width: "20%", minWidth: "150px"}}>Clinic Name</th>
                  <th scope="col" style={{ width: "12%", minWidth: "100px"}}>Clinic Photo</th>
                  <th scope="col" style={{ width: "28%", minWidth: "180px"}}>Address</th>
                  <th scope="col" style={{ width: "15%", minWidth: "160px"}}>Email</th>
                  <th scope="col" style={{ width: "10%", minWidth: "130px", whiteSpace: "nowrap" }}>Phone No.</th>
                  <th scope="col" style={{ width: "15%", minWidth: "180px"}}>Operational Hours</th>
                </tr>
              </thead>
              <tbody className="profile-info-value">
                {locations_array.map((location, index) =>(
                  <tr key={location.id || index}>
                    <td className="align-middle">{location.name || "-"}</td>
                    <td className="align-middle text-center">
                      {location.photo_url ? (
                        <a
                          href={location.photo_url} 
                          target="_blank"
                          rel="noopener noreferrer"
                          className="photo-link"
                        >
                          View Photo
                        </a>
                      ) : (
                        <span className="text-muted small">-</span>
                      )}
                    </td>
                    <td className="align-middle">
                      {location.address}
                    </td>
                    <td className="align-middle">{location.email ? (
                      <a className="photo-link" href={`mailto: ${location.email}`}>{location.email}</a>
                    ) : ("-")
                    }</td>
                    <td className="align-middle">{location.phone || "-"}</td>
                    <td className="align-middle">
                      {location.operating_hours && location.operating_hours.length > 0 ? (
                        <ul className="list-unstyled mb-0 small">
                          {location.operating_hours.map((hour, i) => (
                          <li key={hour.id || i} className="mb-1">
                            <span>{formatText(hour.day_of_week)}:</span> {formatTime(hour.open_time)} - {formatTime(hour.close_time)}
                          </li>
                        ))}
                        </ul>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </ProfileSectionCard>
  );
};

export default PracticeLocations;